import ColumnLayout from './ColumnLayout'

export default ColumnLayout